import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { SelectionToggleType } from '../../../../enums/SelectionToggleType';
import { Icon, OptionItem, OptionItemLabel } from '../../../style';
import { IndeterminateCheckBox } from '../../indeterminate-checkbox/IndeterminateCheckBox';

type SelectionToggleProps = {
  selected: boolean;
  indeterminate?: boolean;
  selectionToggleType?: SelectionToggleType;
  toggleSelection: () => void;
};

const SelectionToggle: FC<SelectionToggleProps> = ({
  selected,
  indeterminate,
  toggleSelection,
  selectionToggleType = SelectionToggleType.SelectUnselect,
}) => {
  const handleChange = (): void => {
    toggleSelection();
  };

  return (
    <OptionItem data-testid='selection-toggle' onClick={handleChange} borderBottom={true}>
      <span className='selection-toggle-text'>
        {selectionToggleType === SelectionToggleType.Reset ? (
          <>
            <ResetIconWrapper data-testid='reset-icon-wrapper'>
              <Icon type='reset' size={theme.typography.fontSize16} />
            </ResetIconWrapper>
            <OptionItemLabel>Reset to Show All</OptionItemLabel>
          </>
        ) : (
          <>
            <IndeterminateCheckBox
              stopPropagation={false}
              cssClass={'form-check-input'}
              indeterminate={indeterminate}
              checked={selected}
            />
            <OptionItemLabel>Select / Unselect All</OptionItemLabel>
          </>
        )}
      </span>
    </OptionItem>
  );
};

export default SelectionToggle;

const ResetIconWrapper = styled.span`
  margin: 4px 7px;
  width: auto !important;
  > span {
    color: ${theme.palette.deepBlueTwo};
  }
`;
